import React from 'react';
import type { Nullable } from 'corgi-types';

import type { DispatchState } from 'common/types/React';
import { CtaSlice as CtaSliceComponent } from './FormTypes/CtaSlice';
import { Form } from './FormTypes/Form';
import type { ContactFormFieldSlice, Settings, UserData } from './types';

interface GetContactFormContent {
  isLoggedIn: boolean;
  reason: string;
  slices: ContactFormFieldSlice[];
  setSlices: DispatchState<ContactFormFieldSlice[]>;
  userData: Nullable<UserData>;
  isChannelSelectionActive: boolean;
  settings: Settings;
  setIsChannelSelectionActive: DispatchState<boolean>;
  skuFromUrl: Nullable<string>;
  orderIdFromUrl: Nullable<string>;
  sellerName: Nullable<string>;
}

const enum ContactFormType {
  CtaSlice = 'cta_block',
}

export const ContactFormContent = ({
  reason,
  slices,
  skuFromUrl,
  orderIdFromUrl,
  sellerName,
  ...restProps
}: GetContactFormContent) => {
  const firstSliceType = slices[0]?.type ?? null;

  switch (firstSliceType) {
    case null:
      return null;
    case ContactFormType.CtaSlice: {
      return <CtaSliceComponent reason={reason} />;
    }
    default:
      return (
        <Form
          slices={slices}
          reason={reason}
          skuFromUrl={skuFromUrl}
          orderIdFromUrl={orderIdFromUrl}
          sellerName={sellerName}
          {...restProps}
        />
      );
  }
};
